module.exports = __webpack_public_path__ + "media/images/promo/championship/arrow-a72c4f664139dc093e04cccfc6dff0f3.png";